import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../data/content';

const FeatureDetailPage = () => {
  const { featureId } = useParams();
  const { language, direction } = useLanguage();
  const features = content[language].features;
  const feature = features.find(f => f.id === featureId);
  const navigate = useNavigate();

  if (!feature) {
    return <div style={{ padding: 40, textAlign: 'center' }}>{language === 'ar' ? 'الميزة غير موجودة' : 'Feature not found'}</div>;
  }

  return (
    <section className="features" style={{ direction, minHeight: '80vh' }}>
      <div className="feature-item slide-up" style={{ maxWidth: 700, margin: '40px auto' }}>
        <span className="feature-icon" style={{ fontSize: '3.5em' }}>{feature.icon}</span>
        <h2>{feature.title}</h2>
        <p style={{ fontSize: '1.2em', margin: '18px 0' }}>{feature.description}</p>
        <h4 style={{ color: 'var(--color-success)', margin: '18px 0 8px 0' }}>{language === 'ar' ? 'أهم الوظائف والمميزات:' : 'Key Functions & Features:'}</h4>
        <ul style={{ textAlign: direction === 'rtl' ? 'right' : 'left', fontSize: '1.1em', marginBottom: 24 }}>
          {feature.highlights && feature.highlights.map((h, i) => (
            <li key={i} style={{ marginBottom: 6 }}>• {h}</li>
          ))}
        </ul>
        <button className="cta-button" onClick={() => navigate('/features')}>
          {language === 'ar' ? 'عودة للميزات' : 'Back to Features'}
        </button>
      </div>
    </section>
  );
};

export default FeatureDetailPage; 